import React from "react";
import { Table } from "antd";
import { Value } from "./value";
import { reduce } from "lodash";
import styled from "styled-components";

const Container = styled.div`
  max-width: 700px;
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 5px;
    border: none;
    text-align: center;
    &:nth-child(2n) {
      background: #f2f2f2;
    }
  }
  .ant-table-thead > tr > th {
    background: none;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: none;
    &:nth-child(2n) {
      background: #f2f2f2;
    }
  }
`;

function ChargeTable({ rates, onChange }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const getDataSource = (rates) => {
    const inverse = inverseData(rates);
    const defaultDataSource = [
      { slot: "am", ...inverse?.am },
      { slot: "pm", ...inverse?.pm },
      { slot: "noc", ...inverse?.noc },
    ];
    return defaultDataSource;
  };

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const inverseData = (rates) =>
    rates &&
    reduce(
      Object.keys(rates),
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (res: any, day) => ({
        am: { ...res.am, [day]: rates[day]?.am },
        pm: { ...res.pm, [day]: rates[day]?.pm },
        noc: { ...res.noc, [day]: rates[day]?.noc },
      }),
      {}
    );

  const renderSlot = (slot) => <span>{slot}</span>;

  const renderValue = (day) =>
    function (value, row) {
      return (
        <span>
          <Value name={`${day}.${row.slot}`} onChange={onChange} unit="$" value={value} />
          /hr
        </span>
      );
    };

  const columns = [
    { title: "", dataIndex: "slot", render: renderSlot },
    { title: "Sun", dataIndex: "sunday", render: renderValue("sunday") },
    { title: "Mon", dataIndex: "monday", render: renderValue("monday") },
    { title: "Tue", dataIndex: "tuesday", render: renderValue("tuesday") },
    { title: "Wed", dataIndex: "wednesday", render: renderValue("wednesday") },
    { title: "Thu", dataIndex: "thursday", render: renderValue("thursday") },
    { title: "Fri", dataIndex: "friday", render: renderValue("friday") },
    { title: "Sat", dataIndex: "saturday", render: renderValue("saturday") },
  ];

  return (
    <Container>
      <Table columns={columns} rowKey="slot" dataSource={getDataSource(rates)} pagination={false} />
    </Container>
  );
}

export { ChargeTable };
